import service from '../request/request'


export const login = (data)=>{
    return service.request({
        url:"user/login",
        method:'post',
        data
    })
}

export const getMenuList = ()=>{
    return service.request({
        url:"sysMenu/getMenuList",
        method:'get'
    })
}

export const getUrl = ()=>{
    return service.request({
        url:"signPc/getUrl",
        method:'GET'
    })
}


export const getLogin = (params)=>{
    return service.request({
        url:"signPc/login",
        method:'GET',
        params
    })
}
export const checkSign = (params)=>{
    return service.request({
        url:"signPc/checkSign",
        method:'GET',
        params
    })
}
export const insertSigninfo = (data)=>{
    return service.request({
        url:"signPc/insertSigninfo",
        method:'POST',
        data
    })
}




export const getOrgListByPid = (params)=>{
    return service.request({
        url:"company/getOrgListByPid",
        method:'GET',
        params
    })
}

export const getConfig = (params)=>{
    console.log(params,'params');
    return service.request({
        url:"signPc/getSysConfig",
        method:'GET',
        params
    })
}
